<template>
  <div class="page-container">
    <el-card>
      <app-filter
        :filter-list="table_filter"
        @search="searchTable"
      />
      <el-button
        style="margin-top: 10px;"
        type="success"
        size="mini"
        @click="exportExcel"
      >导出</el-button>
      <el-button
        style="margin-top: 10px;"
        size="mini"
        @click="pullMaterialReport"
      >重导</el-button>
    </el-card>
    <el-card class="mt-20">
      <div class="flex justify-end align-center">
        <!-- 导入表格 -->
        <el-upload
          action="#"
          :accept="upload_config.accept"
          :show-file-list="false"
          :http-request="upload_config.uploadHandler"
          :before-upload="upload_config.onBeforeUpload"
          :on-success="upload_config.onUploadSuccess"
        >
          <el-button size="mini">导入表格</el-button>
        </el-upload>
        <!-- 下载模板 -->
        <el-link class="ml-10" href="/file/cost_file.xlsx" download="cost_file.xlsx" target="_blank" :underline="false">下载录入本地素材费用模板</el-link>
      </div>
      <app-table
        ref="my-table"
        class="mt-20"
        height="800px"
        :expand="expand_obj.is_show"
        :expand-template="expand_obj.template"
        :table-key="table_key"
        :table-props="table_props"
        :table-on="table_on"
        :tablep="material_report_params"
        :get-data="getMaterialReportList"
      />
    </el-card>
  </div>
</template>

<script>
import { transformSchema } from '@/utils';
import { getChannelInterfaceApi } from '@/api/channel-interface';

// 素材报表列表接口
import ReportResource from '@/api/report/index';
const reportResource = new ReportResource();

// 获取游戏列表接口
import AdvertisingResource from '@/api/advertising';
const advertisingResource = new AdvertisingResource();

// 获取用户列表接口
import UserResource from '@/api/user';
const userResource = new UserResource();

// 获取投放账号列表接口
import MediasResource from '@/api/medias';
const mediasResource = new MediasResource();

import { pullJrttMaterialReportApi } from '@/api/material/report/jrtt';
import { pullGdtMaterialReportApi } from '@/api/material/report/gdt';
import { CHANNEL_INTERFACE_TYPE } from '@/enums';

export default {
  components: {
    'material-preview': () => import('../components/material-preview'),
    'app-table': () => import('@/components/app-table'),
    'app-filter': () => import('@/components/app-filter'),
  },
  data() {
    return {
      /** 上传配置 */
      upload_config: {
        accept: 'application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        uploadHandler: this.uploadHandler,
        onBeforeUpload: this.onBeforeUpload,
        onUploadSuccess: this.onUploadSuccess,
      },
      /** 素材报表列表参数 */
      material_report_params: {
        page: 1,
        limit: 10,
        advertisers: ['gdt'],
      },
      /** 素材报表拓展列表参数 */
      report_expand_params: {
        page: 1,
        limit: 20,
      },
      /** 表格属性 */
      table_props: {
        border: true,
        'show-summary': true,
        'summary-method': this.getSummaries,
        'max-height': '690px',
        /** 要展开的行，数值的元素是row的key值 */
        'expand-row-keys': [],
      },
      /** 表格事件 */
      table_on: {
        'sort-change': ({ column, prop, order }) => {
          this.material_report_params['sort_prop'] = prop;

          if (order === 'descending') {
            this.material_report_params['sort_order'] = 'DESC';
          } else if (column.order === 'ascending') {
            this.material_report_params['sort_order'] = 'ASC';
          } else {
            delete this.material_report_params.sort_order;
            delete this.material_report_params.sort_prop;
          }
          this.$refs['my-table'].seekTable();
        },
        'expand-change': (row, expandedRows) => {
          if (expandedRows.length) {
            this.table_props['expand-row-keys'] = [];
            this.table_props['expand-row-keys'].push(row.id);

            if (this.material_report_params.sort_order && this.material_report_params.sort_prop) {
              delete this.material_report_params.sort_order;
              delete this.material_report_params.sort_prop;
            }

            this.report_expand_params.start_date = this.table_filter.start_date.value[0];
            this.report_expand_params.end_date = this.table_filter.start_date.value[1];
            this.report_expand_params.advertisers = this.table_filter.advertisers.value;
            this.report_expand_params.local_material_id = row.material.id;
          }
        },
      },
      /** 扩展表格事件 */
      expand_table_on: {
        'sort-change': ({ column, prop, order }) => {
          this.report_expand_params['sort_prop'] = prop;

          if (order === 'descending') {
            this.report_expand_params['sort_order'] = 'DESC';
          } else if (column.order === 'ascending') {
            this.report_expand_params['sort_order'] = 'ASC';
          } else {
            delete this.report_expand_params.sort_order;
            delete this.report_expand_params.sort_prop;
          }
          this.expand_obj.is_show = false;
          this.$nextTick(() => {
            this.expand_obj.is_show = true;
          });
        },
      },
      /** 列合计 */
      summary: {},
      /** 扩展元素对象 */
      expand_obj: {
        is_show: true,
        template: (data) => {
          const h = this.$createElement;

          const ele = h('div',
            {
              class: 'expand-box',
            }, [
              h('app-table', {
                props: {
                  'table-props': {
                    'max-height': '300px',
                  },
                  'table-key': this.table_key_extend,
                  'tablep': this.report_expand_params,
                  'pageSizes': [20, 40, 60],
                  'get-data': this.getMaterialReportList,
                  'table-on': this.expand_table_on,
                },
              }, null),
            ]);
          return ele;
        },
      },
      /** 筛选条件 */
      table_filter: require('./module/table-filter.js')(this),
      /** 表格头部 */
      table_key: require('./module/table-key.js')(this),
      /** 扩展表格头部 */
      table_key_extend: require('./module/table-key-extend.js')(this),
      /** 渠道接口类型表 */
      channel_interface_map: {},
    };
  },
  created() {
    const date = this.getTodayDate();
    this.table_filter.start_date.value = [date, date];

    this.material_report_params.start_date = this.table_filter.start_date.value[0];
    this.material_report_params.end_date = this.table_filter.start_date.value[1];
    // 获取渠道接口
    this.getChannelInterface();
    // 获取组员列表
    this.getMembersList();
    // 获取投放账号
    this.getMediasList({ type: 'gdt', is_list: true });
    // 获取游戏列表（素材）
    this.getGameList({ refresh: 1, is_parent: 1 }).then((res) => {
      for (let i = 0; i < res.list.length; i++) {
        res.list[i]['disabled'] = true;
      }
      this.table_filter.material_parent_game_ids.props.options = res.list;
    });
    // 获取投放游戏
    this.getGameList({ refresh: 1 }).then((res) => {
      for (let i = 0; i < res.list.length; i++) {
        res.list[i]['disabled'] = true;
      }
      this.table_filter.game_ids.props.options = res.list;
    });
    // 获取需求人列表
    this.getUserList({ limit: -1 }).then((res) => {
      this.table_filter.demand_sider_ids.options = res.data.map(item => {
        return {
          label: item.name,
          value: item.id,
        };
      });
    });
    // 获取作者列表
    this.getUserList({ limit: -1, page: 'local_material' }).then((res) => {
      this.table_filter.author_ids.options = res.data.map(item => {
        return {
          label: item.name,
          value: item.id,
        };
      });
    });
  },
  methods: {
    /**
     * 各项数据总和
     * @param {Object} param 表格数据对象
     */
    getSummaries(param){
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 1) {
          sums[index] = '合计';
          return;
        }

        if (Object.prototype.hasOwnProperty.call(this.summary, column.property)) {
          sums[index] = this.summary[column.property];
        } else {
          index === 0 ? '' : sums[index] = 'N/A';
        }
      });
      return sums;
    },
    /** 获取渠道接口类型 */
    getChannelInterface() {
      return new Promise((resolve, reject) => {
        getChannelInterfaceApi().then((res) => {
          const result = (res.list || []).map(({ id, name }) => ({ label: name, value: id }));
          this.table_filter.advertisers.options = result;
          this.channel_interface_map = transformSchema(result);
          resolve(res);
        }).catch(reject);
      });
    },
    /** 获取组员列表 */
    getMembersList() {
      return new Promise((resolve, reject) => {
        userResource
          .getMembersList()
          .then((response) => {
            this.table_filter.child_user_ids.options = response.list.map(item => {
              return {
                label: item.name,
                value: item.id,
              };
            });
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    /** 获取投放账号 */
    getMediasList(params) {
      return new Promise((resolve, reject) => {
        mediasResource
          .getMediasListApi(params)
          .then((response) => {
            this.table_filter.advertiser_ids.options = response.list.map(item => {
              return {
                label: item.advertiser_name,
                value: item.advertiser_id,
              };
            });
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    /** 获取素材列表 */
    getMaterialReportList(params) {
      return new Promise((resolve, reject) => {
        reportResource
          .getMaterialReportListApi(params)
          .then((response) => {
            this.summary = response?.summary || {};
            response.list = response.list.map((item, index) => ({ ...item, id: `${item.material.id}-${index}` }));
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    /** 获取游戏列表 */
    getGameList(params) {
      return new Promise((resolve, reject) => {
        advertisingResource
          .getGameListApi(params)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    /** 获取游戏列表 */
    getUserList(params) {
      return new Promise((resolve, reject) => {
        userResource
          .getUserList(params)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    /**
     * 自定义上传
     * @param {Object} options 上传配置对象
     */
    uploadHandler(options) {
      const form_data = new FormData();
      form_data.append('cost_file', options.file);
      return this.batchUploadCost(form_data);
    },
    /**
     * 上传前判断文件格式
     * @param {Object} file 上传的file格式文件
     */
    onBeforeUpload(file){
      const isType = file.type === 'application/vnd.ms-excel';
      const isTypeComputer = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      const fileType = isType || isTypeComputer;
      if (!fileType) {
        this.$message.error('上传文件只能是xls/xlsx格式！');
      }
      return fileType;
    },
    /**
     * 上传成功
     * @param {Object} response 接口成功返回的参数
     */
    onUploadSuccess(response){
      this.$message.success(response.message);
      this.$refs['my-table'].seekTable();
    },
    /** 导出表格 */
    exportExcel() {
      const export_params = JSON.parse(JSON.stringify(this.material_report_params));
      export_params['is_export'] = 1;
      this.exportMaterialReport(export_params).then((res) => {
        this.downloadCsv(res, export_params);
      });
    },
    /** 导出表格接口 */
    exportMaterialReport(params) {
      return new Promise((resolve, reject) => {
        reportResource
          .exportMaterialReportApi(params)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    /**
     * 下载csv
     * @param {Object} res 接口返回的blob格式参数
     * @param {Object} export_params 导出时的请求参数
     */
    downloadCsv(res, export_params) {
      const blob = new Blob([res], { type: 'text/csv' });
      if ('download' in document.createElement('a')){
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.download = `${export_params.start_date}_${export_params.end_date}.csv`;
        link.href = url;
        link.click();
        // 释放内存
        URL.revokeObjectURL(url);
      } else {
        // ie10下载
        navigator.msSaveOrOpenBlob(blob);
      }
    },
    /**
     * 搜索表格
     * @param {Object} obj 过滤对象参数
     */
    searchTable(obj) {
      if (obj.start_date) {
        obj['end_date'] = obj.start_date[1];
        obj['start_date'] = obj.start_date[0];
      } else {
        obj['end_date'] = null;
        obj['start_date'] = null;
      }
      !obj?.advertiser_ids && delete this.material_report_params.advertiser_ids;
      Object.assign(this.material_report_params, obj);
      this.$refs['my-table'].seekTable();
    },
    /** 录入素材费用接口 */
    batchUploadCost(params) {
      return new Promise((resolve, reject) => {
        reportResource
          .batchUploadCostApi(params)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    /**
     * 获取当日日期
     * @returns {string} yyyy-mm-dd格式日期
     */
    getTodayDate() {
      const today = new Date();
      const day = String(today.getDate()).padStart(2, '0');
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const year = today.getFullYear();
      return `${year}-${month}-${day}`;
    },
    /**
     * 重导素材报表数据
     * @returns {void}
     */
    pullMaterialReport() {
      const { start_date, advertisers, advertiser_ids } = this.table_filter;

      if (!start_date.value.length) {
        this.$message.warning('请选择日期');
        return;
      }

      const is_only_gdt = advertisers.value.length === 1 && advertisers.value[0] === CHANNEL_INTERFACE_TYPE.GDT;
      const is_only_jrtt = advertisers.value.length === 1 && advertisers.value[0] === CHANNEL_INTERFACE_TYPE.JRTT;
      const is_single_adv_id = advertiser_ids.value.length === 1;
      const is_valid = (is_only_gdt || is_only_jrtt) && is_single_adv_id;

      if (!is_valid) {
        this.$message.warning('仅支持广点通或头条媒体的单个广告主重导');
        return;
      }

      const payload = {
        advertiser_id: advertiser_ids.value[0],
        start_date: start_date.value[0],
        end_date: start_date.value[1],
      };

      const h = this.$createElement;
      const message_ele = h('div', null, [
        h('span', null, '确定重导'),
        h('span', { class: 'color-red ml-5 mr-5' }, payload.advertiser_id),
        h('span', null, '广告主，'),
        h('span', { class: 'color-red ml-5 mr-5' }, payload.start_date),
        h('span', null, '至'),
        h('span', { class: 'color-red ml-5 mr-5' }, payload.end_date),
        h('span', null, '的素材数据吗？'),
      ]);
      this.$msgbox({
        title: '提示',
        message: message_ele,
        showCancelButton: true,
      }).then(() => {
        this.pullMaterialReportApi(is_only_gdt ? CHANNEL_INTERFACE_TYPE.GDT : CHANNEL_INTERFACE_TYPE.JRTT)(payload).then(({ message }) => {
          this.$message.success(message || '重导成功');
        });
      });
    },
    /**
     * 重导素材报表数据接口
     * @param {string} channel_interface 渠道接口类型
     * @returns {Function}
     */
    pullMaterialReportApi(channel_interface) {
      const strategy = {
        [CHANNEL_INTERFACE_TYPE.GDT]: pullGdtMaterialReportApi,
        [CHANNEL_INTERFACE_TYPE.JRTT]: pullJrttMaterialReportApi,
      };
      return strategy[channel_interface];
    },
  },
};
</script>
